import styled from 'styled-components';
import { colors } from 'definitions';

// Container del ListOf: scroll natural del body (sin altura fija).
// El paginador queda sticky al bottom del viewport mientras hay contenido encima,
// y se "settle" en su posición natural cuando llegás al final de la lista.
export const Container = styled.div`
	max-width: 124.5rem;
	padding-top: 3rem;
	width: 95%;
	display: flex;
	flex-direction: column;
`;

export const ItemsScrollArea = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ContainerItem = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 2rem;
	flex-basis: 49%;
	border-radius: 6px;
`;

// Sticky al bottom del viewport. Cuando el container del ListOf llega arriba del
// viewport (scrolleo casi todo), el paginador se queda pegado abajo. Cuando
// llegás al final, se "despega" naturalmente en su posición real.
// background-color sólido + z-index para que los items no se vean por debajo.
// box-shadow arriba para indicar visualmente que es una capa "flotante".
export const PaginationFooter = styled.div`
	position: sticky;
	bottom: 0;
	width: 100%;
	background-color: ${colors.background.white};
	box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
	z-index: 10;
`;
